<template>
	<span class="my-bookmark__info">
		<span class="ico-bookmark"></span>
		<span>북마크한 글</span>
		<em>{{count}}</em>
	</span>
</template>

<script>
	export default {
		props: ['tags', 'focusedTag', 'total'],
		computed: {
			count() {
				const nf = Intl.NumberFormat();
				if (!this.focusedTag) {
					return nf.format(this.total);
				}
				return `${nf.format(this.tags.find(v => v.id === this.focusedTag).taggingCount)}/${nf.format(this.total)}`;
			}
		},
	}
</script>
